
import Loadable from '../../../../components/loadable';
import prerenderedLoadable from '../../../../components/prerender';

const Page = Loadable(() => import('./index'));

export default prerenderedLoadable(Page);
